<template>
  <div>
    <el-dialog :title="title" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
               :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%"
               style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
               @close="dialogClose" v-el-drag-dialog v-el-dialog-center>

      <!-- 品牌信息 -->
      <div class="detail-wrap">
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div>
              <el-row v-if="'出库' === this.type">
                <el-form :model="formData" label-width="100px">
                  <el-col :span="6">
                    <el-form-item label="配送方式" :rules="{required: true}">
                      <dict-select :dict-item-id.sync="formData.deliverType"
                                   :dict-item-name.sync="formData.deliverTypeName"
                                   dict-type="配送方式"/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="物流公司" :rules="{required: true}">
                      <dict-select dict-type="物流公司"
                                   :dict-item-name.sync="formData.deliverCompanyName"
                                   :dict-item-id.sync="formData.deliverCompany"/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="物流单号" :rules="{required: true}">
                      <el-input type="text" autocomplete="off" v-model="formData.deliverNo" style="width: 160px ;"
                                clearable/>
                    </el-form-item>
                  </el-col>
                </el-form>
              </el-row>
            </div>
            <el-row>
              <el-col :span="24">
                <vxe-table
                  style="margin-top: 0px;"
                  :stripe="true"
                  :header-cell-style="{height: '30px',  background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                  :row-config="{height: 30,isHover: true,padding: 0,}"
                  :row-style="{ fontSize: '12px',  }"
                  show-overflow
                  height="300"
                  :column-config="{ resizable: true }"
                  @checkbox-change="selectChangeEvent"
                  @checkbox-all="selectChangeEvent"
                  :data="formData.spWhtowhLineDTOList">
                  <!--                  <vxe-column type="checkbox" width="40"/>-->
                  <vxe-column field="partsCode" title="配件编码" width="260"></vxe-column>
                  <vxe-column field="partsName" title="配件名称" width="280"></vxe-column>
                  <vxe-column field="invQty" title="库存数量" width="100"></vxe-column>
                  <vxe-column field="takeUpQty" title="占用数量" width="100"></vxe-column>
                  <vxe-column field="qty" title="申请数量" width="100"></vxe-column>
                  <vxe-column field="checkQty" title="审核数量" width="100">
                    <template #default="{row}">
                      <vxe-input size="small"
                                 v-if="type === '审核'"
                                 v-model="row.checkQty"
                                 type="number"
                                 min="0"
                                 :max="Number(row.invQty) > 0 ? row.invQty : 0"
                                 :clearable="false"
                                 @input="inputFunc(row, 'check')"
                      />
                      <span v-else>{{ row.checkQty }}</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="qty" title="出库数量" v-if="type==='出库'||type==='入库'" width="100">
                    <template #default="{row}">
                      <vxe-input size="small"
                                 v-if="type === '出库'"
                                 v-model="row.outQty"
                                 type="number"
                                 min="0"
                                 :max="row.checkQty"
                                 :clearable="false"
                                 @input="inputFunc(row, 'out')"
                      />
                      <span v-else>{{ row.outQty }}</span>
                    </template>
                  </vxe-column>
                  <vxe-column field="inQty" title="入库数量" v-if="type==='入库'" width="100">
                    <template #default="{row}">
                      <vxe-input size="small"
                                 v-model="row.inQty"
                                 type="number"
                                 min="0"
                                 :max="row.outQty"
                                 :clearable="false"
                                 @input="inputFunc(row, 'in')"
                      />
                    </template>
                  </vxe-column>
                </vxe-table>
              </el-col>
            </el-row>
          </div>


        </div>
      </div>
      <span slot="footer" class="dialog-footer">

			  <el-button type="primary" plain class="button-sty" @click="dialogClose">
				  <i class="el-icon-close el-icon"></i>
				  取 消
			  </el-button>
			  <el-button type="primary" @click="doAudit" class="button-sty">
				  <i class="el-icon-check el-icon"></i>
				  确 定
			  </el-button>
		  </span>
    </el-dialog>

  </div>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import pager from '@/components/pager/index.vue';
import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
import orderDialog from '@/views/dialogCommon/radioOrderDialog.vue';
import store from "@/store";
import api from "@/api/projectApi";
import {echoFileFormat, uploadFileFormat} from "@/util/uploadFormat";
import {dictType, loadDictData} from "@/config/dictType";
import DictSelect from "@/components/formItem/dictSelect.vue";

export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'type', 'id'],
  mixins: [selectDialogMixins],
  components: {DictSelect, preconditionDialog, pager, orderDialog},

  created() {
    this.initSetting()
  },

  watch: {
    // 'formData.deliverType': {
    //   handler(newVal) {
    //     if (newVal !== null && newVal !== undefined) {
    //       this.shippingMethodList.forEach(item => {
    //         if (newVal === item.value) {
    //           this.formData.deliverTypeName = item.label
    //         }
    //       })
    //     }
    //   },
    //   deep: true
    // },
    //
    // 'formData.deliverCompany': {
    //   handler(newVal) {
    //     if (newVal !== null && newVal !== undefined) {
    //       this.logisticsCompaniesList.forEach(item => {
    //         if (newVal === item.value) {
    //           this.formData.deliverCompanyName = item.label
    //         }
    //       })
    //     }
    //   },
    //   deep: true
    // }
  },

  mounted() {
    if (this.type) {
      this.formData.type = this.type
      if (this.type === '审核') {
        this.title = '配件审核'
        this.url = api.spWhtowhHead.auditDataUrl
      } else if (this.type === '出库') {
        this.title = '配件出库'
        this.url = api.spWhtowhHead.outboundUrl
        // this.loadDictData()
      } else if (this.type === '入库') {
        this.title = '配件入库'
        this.url = api.spWhtowhHead.inboundUrl
      }
    }
    this.loadData()
  },

  computed: {},

  data() {
    return {
      showEdit: false,
      title: null,
      shippingMethodList: [],
      logisticsCompaniesList: [],
      url: null,

      formData: {
        id: null,
        spWhtowhLineDTOList: [],
        type: null,

        deliverCompany: null,
        deliverCompanyName: null,
        deliverType: null,
        deliverTypeName: null,
        deliverNo: null,
      },
      showOrderDialog: false,
      showDialog: true,
      falseValue: false,
      selectMulti: true,


    };
  },


  methods: {
    inputFunc(row, type) {
      console.log('------------')
      let invQty = Number(row.invQty)
      // let invQty = Number(row.invQty) - Number(row.takeUpQty) > 0 ? (row.invQty) - Number(row.takeUpQty) : 0
      if (type === 'check') {
        if (Number(row.checkQty) > invQty) {
          this.$message.error('审核数量不能大于库存数量')
          row.checkQty = invQty
        }
        if (Number(row.checkQty) > Number(row.qty)) {
          this.$message.error('审核数量不能大于申请数量')
          row.checkQty = row.qty
        }
      } else if (type === 'out') {
        if (Number(row.outQty) > Number(row.checkQty)) {
          this.$message.error('出库数量不能大于审核数量')
          row.outQty = Number(row.checkQty)
        }
      } else if (type === 'in') {
        if (Number(row.outQty < row.inQty)) {
          this.$message.error('入库数量不能大于出库数量')
          row.inQty = row.outQty
        }
      }
    },

    // 加载明细与库存数据
    loadData() {
      this.$http.post(api.spWhtowhHead.getLineDataUrl, {id: this.id}).then(res => {
        let data = res.data.data
        console.log(data, '明细数据')

        if (this.type === '审核') {
          data.forEach(item => {
            item.checkQty = item.qty
          })
        } else if (this.type == '出库') {
          data.forEach(item => {
            item.outQty = item.checkQty
          })
        } else if (this.type == '入库') {
          data.forEach(item => {
            item.inQty = item.outQty
          })
        }
        this.formData.spWhtowhLineDTOList = data
        this.formData.id = this.id
      })
    },


    doAudit() {
      if (this.type === '出库') {
        if (!this.formData.deliverCompany) {
          this.$message.warning('请选择物流公司')
          return
        }
        if (!this.formData.deliverType) {
          this.$message.warning('请选择配送方式')
          return
        }
        if (!this.formData.deliverNo) {
          this.$message.warning('请填写物流单')
        }
      }
      this.$mask.open()

      this.$http({
        url: url,
        method: 'post',
        data: this.formData
      }).then(res => {
        this.$message.success('操作成功')
        this.$emit('closeD')
        this.$emit('goBackIndex')
      }).catch(e => {
        console.error(e)
        this.loadData()
      })
      this.$mask.close()

    },

    // // 加载数据字典中物流公司，运输方式
    // loadDictData() {
    //   // 物流公司
    //   loadDictData(dictType.logisticsCompanies).then(res => {
    //     this.logisticsCompaniesList = []
    //     res.data.data.forEach(item => {
    //       this.logisticsCompaniesList.push({
    //         label: item.label,
    //         value: item.id
    //       })
    //     })
    //     console.log(this.logisticsCompaniesList, '物流公司')
    //   })
    //
    //   // 运输方式
    //   loadDictData(dictType.shippingMethod).then(res => {
    //     this.shippingMethodList = []
    //     res.data.data.forEach(item => {
    //       this.shippingMethodList.push({
    //         label: item.label,
    //         value: item.id
    //       })
    //     })
    //     console.log(this.shippingMethodList, '运输方式')
    //   })
    // },


  }
};
</script>
<style lang="scss" scoped>
.papers {
  position: absolute;
  left: 292px;
  top: 0px;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

// ::v-deep .el-dialog {
//     margin-top: 110px !important;
//     overflow: hidden;
// }


.d-item {
  border: 1px solid #ededed;
}

.table-detail {
  padding-left: 35px;
  display: inline-block;
}

.table-detail tr {
  margin-bottom: 10px;
  display: inline-block;

  th {
    font-weight: 400;
    text-align: right;
    width: 112px;
    font-size: 12px;
    position: relative;
    padding: 0 10px 0 4px;
    color: rgba(86, 86, 86, 0.96);

  }

  // td{
  // 	display: inline-block;
  // 	width: 170px !important;
  // }
}

::v-deep tbody tr td .el-input {
  width: 100% !important;
  width: 165px !important;
}

.title b {
  display: inline-block;
  line-height: 28px;
  font-size: 16px;
  font-weight: 600;
  margin-right: 84px;
  vertical-align: middle;
  color: #00c4b3;
  position: relative;
  z-index: 2;
  background: rgba(42, 100, 148, 0.16);
  margin-left: 0px;
  margin-top: 8px;
  padding-left: 12px;
  padding-right: 14px;
  border-radius: 0 28px 28px 0;
}

.detail-wrap {
  background-color: #fff;
  padding: 5px;
}

// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 570px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    > span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  & > .el-tree-node::after {
    border-top: none;
  }

  & > .el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}

.btn_zdy {
  margin: 10px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  // margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

.vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

::v-deep .el-col{
  margin-bottom: 0;
  margin-top: 3px;
}

::v-deep .el-select>.el-input {
  margin-top: 3px;
}

::v-deep .el-input {
  margin-top: 3px;
}
</style>
